import React, { useEffect, useContext, useState, useActionState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import Icon_Building from '../../Assets/Icons/Icon_Building.png';
import Icon_Floor from '../../Assets/Icons/Icon_Floor.png';
import Icon_Room from '../../Assets/Icons/Icon_Room.png';
import Icon_Color_ImageNotFound from '../../Assets/Icons/Icon_Color_ImageNotFound.png';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useStatus } from '../../Contexts/Context_Status_Global';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import UI_Toggle from '../ERUMAUI/UI_Toggle';

export default function Subwindow_Templating_EditBlockedHours({ zIndex, isActive, id }) {
    const UI = useContext(Context_UI);
    const [ID_ActiveDropdown, ID_ActiveDropdown_Set] = useState(null);
    const [ID_ActiveForm, ID_ActiveForm_Set] = useState("Building");
    const [Image_Source, Image_Source_Set] = useState(null);
    const [Floor_Name_Suggestion, Floor_Name_Suggestion_Set] = useState(null);
    const [Floor_Name_Suggestion_Lock, Floor_Name_Suggestion_Lock_Set] = useState(null);
    const [Floor_Building, Floor_Building_Set] = useState(null);
    const [Room_Building, Room_Building_Set] = useState(null);
    const [Room_Floor, Room_Floor_Set] = useState(null);
    const [Room_Floor_List, Room_Floor_List_Set] = useState([]);
    const { Template_List } = useTemplating();
    const { Template_RoomType_EditData, Template_RoomType_EditData_Set } = useTemplating();
    const { Status_Refresh_Set, Status_Fetching_Set, Status_Saving_Set, Confirmer_Respond } = useStatus();
    const Navigate = useNavigate();
    const Confirm = async () => {
        const Hours = Template_RoomType_EditData.DefinedHours;
        const Inputs = Hours.reduce((Hours, Item, Index) => {
            if (Item.hasDefinedHours) {
                Hours.push({
                    Type: "Time_Range",
                    ID_Start: `BlockedDay_${Index}_Start`,
                    ID_End: `BlockedDay_${Index}_End`,
                    AC: "Past",
                    Prompt: "End time must be after start time"
                });
            }
            return Hours;
        }, []);
        const Valid = await UI.Input_Evaluate(Inputs);
        if (Valid) {
            Confirmer_Respond(true, { Data: Template_RoomType_EditData }, true, "Window_Templating_EditBlockedHours");
        }
    }

    const Cancel = () => {
        Confirmer_Respond(false, {}, true, "Window_Templating_EditBlockedHours");
    }

    const Format_Time = (dateTemp, Type) => {
        const date = new Date(dateTemp);
        if (!(date instanceof Date) || isNaN(date)) return "?";
        const pad = (n) => String(n).padStart(2, "0");
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());

        switch (Type) {
            case "date":
                return `${year}-${month}-${day}`;
            case "time":
                return `${hours}:${minutes}`;
            case "datetime-local":
                return `${year}-${month}-${day}T${hours}:${minutes}`;
            default:
                return "";
        }
    }

    useEffect(() => {
        const Handle_Toggle_BlockedDay = ({ ID, State }) => {
            const Index = ID.split("_")[1];
            // console.log(State);
            Handle_Toggle(Index, State);
        }
        UI.on("Button_Toggled", Handle_Toggle_BlockedDay);
        return () => {
            UI.off("Button_Toggled", Handle_Toggle_BlockedDay)
        };
    });

    const Handle_Toggle = (Index, State) => {
        const Templates_Updated = { ...Template_RoomType_EditData };
        let State_New = false;
        if (State === "Active") {
            State_New = true;
        } else {
            State_New = false;
        }
        Templates_Updated.DefinedHours[Index].hasDefinedHours = State_New;
        Template_RoomType_EditData_Set(Templates_Updated);
    }

    const Handle_Change = async (Event, Index, Side) => {
        // console.log(Event.target.value);
        const Verdict = await UI.Input_Evaluate([
            {
                Type: "Time_Range",
                ID_Start: `BlockedDay_${Index}_Start`,
                ID_End: `BlockedDay_${Index}_End`,
                AC: "Past",
                Prompt: "Invalid time"
            }
        ]);
        const Templates_Updated = { ...Template_RoomType_EditData };
        const Value = new Date(`2025-10-15T${Event.target.value}`);
        if (Side === "Start") {
            Templates_Updated.DefinedHours[Index].Start = Value;
        } else if (Side === "End") {
            Templates_Updated.DefinedHours[Index].End = Value;
        }
        
        Template_RoomType_EditData_Set(Templates_Updated);
    }

    return (
        <ui-subwindow Type='Subwindow' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    Edit room type blocked hours
                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Cancel}>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content style={{ minHeight: "500px", paddingRight: "10px" }}>
                <h2 className='General_Title'>
                    {Template_RoomType_EditData?.Name}
                </h2>
                <table className='TP_BlockedHours'>
                    <thead>
                        <tr>
                            <td>
                                <p className='General_Paragraph'>
                                    Day
                                </p>
                            </td>
                            <td>
                                <p className='General_Paragraph'>
                                    Has blocked hours?
                                </p>
                            </td>
                            <td>
                                <p className='General_Paragraph'>
                                    Start time
                                </p>
                            </td>
                            <td>
                                <p className='General_Paragraph'>
                                    End time
                                </p>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        {Template_RoomType_EditData.DefinedHours.map((Item, Index) => (
                            <tr>
                                <td>
                                    <p className='General_Paragraph'>
                                        {Item.Day}
                                    </p>
                                </td>
                                <td>
                                    <UI_Toggle
                                        Text="Has blocked hours"
                                        id={`BlockedDay_${Index}`}
                                        Type="Switch"
                                        Selected={Item.hasDefinedHours ? "true" : "false"}
                                    />
                                </td>
                                <td>
                                    {Item.hasDefinedHours ?
                                        <UI_Input_Text
                                            id={`BlockedDay_${Index}_Start`}
                                            Input_Type='time'
                                            Value={Format_Time(Item.Start, "time")}
                                            onChange={(Event) => Handle_Change(Event, Index, "Start")}
                                        />
                                        :
                                        <p className='General_Paragraph'>
                                            Free all day
                                        </p>
                                    }
                                    
                                </td>
                                <td>
                                    {Item.hasDefinedHours ?
                                        <UI_Input_Text
                                            id={`BlockedDay_${Index}_End`}
                                            Input_Type='time'
                                            Value={Format_Time(Item.End, "time")}
                                            onChange={(Event) => Handle_Change(Event, Index, "End")}
                                        />
                                        :
                                        <p className='General_Paragraph'>
                                            -
                                        </p>
                                    }
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Cancel}>
                    Cancel
                </button>
                <button className='General_Button Subwindow_Control' Type='Primary' onClick={Confirm}>
                    Save changes
                </button>
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
